import { apiV2, errorHandler } from "./index";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import { API_ERROR, FETCH_ALL_SERIES, FETCH_ALL_SERIES_START } from "../constants/ActionTypes";

export function fetchAllSeries() {
  return function (dispatch) {
    dispatch({
      type: FETCH_ALL_SERIES_START
    });

    apiV2.get('/series')
      .then(response => {
        dispatch({
          type: FETCH_ALL_SERIES,
          payload: response.data.objects
        });
      })
      .catch(error => {
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}

export function addEditSeries(options, onSuccess) {
  return function (dispatch) {
    // options.series_json is a JSON string from the component; parse it to get flat fields
    const seriesData = typeof options.series_json === 'string'
      ? JSON.parse(options.series_json)
      : options.series_json;

    // options.session_ids_json is a JSON string from the component; parse it
    const sessions = typeof options.session_ids_json === 'string'
      ? JSON.parse(options.session_ids_json)
      : options.session_ids_json;

    const {
      series_title,
      series_description,
      series_is_active,
      series_image,
      series_is_new,
      series_is_dark_mode,
      series_text_image_url,
    } = seriesData;

    const payload = {
      series_title,
      series_description,
      series_is_active,
      series_image,
      series_is_new,
      series_is_dark_mode,
      series_text_image_url,
      category_id: options.category_id,
      sessions,
    };

    const request = seriesData.series_id
      ? apiV2.put(`/series/${seriesData.series_id}`, payload)
      : apiV2.post('/series', payload);

    request
      .then(response => {
        Swal.fire({
          icon: "success",
          title: "Saved!",
          timer: 1000
        }).then(() => {
          onSuccess?.();
        });
      })
      .catch(error => {
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}

export function clearAllSeries() {
  return function (dispatch) {
    dispatch({
      type: FETCH_ALL_SERIES,
      payload: null
    });
  };
}

export function deleteSeries(series_id, onSuccess) {
  return function (dispatch) {
    apiV2.delete(`/series/${series_id}`)
      .then(response => {
        Swal.fire({
          icon: "success",
          title: "Series Deleted!",
          timer: 1000
        }).then(() => {
          onSuccess?.();
        });
      })
      .catch(error => {
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}
